import React from 'react'
import { Skeletons } from '@usap/widgets'
import ShoppingCartV2 from './ShoppingCartV2'
import useIsWmoEnabled from '../hooks/useWmoEnabled'

const ShoppingCart = props => {
  const {
    apiDetails,
  } = props
  const { Cart: CartSkeleton, CartWmo: CartSkeletonWmo } = Skeletons

  if (__BROWSER__ && window.localStorage) {
    window.localStorage.removeItem('paymentMethod')
    window.localStorage.removeItem('paymentMethodExpressCheckout')
  }

  const isWmoEnabled = useIsWmoEnabled()

  if (!__BROWSER__) {
    if (isWmoEnabled) {
      return <CartSkeletonWmo />
    }
    return <CartSkeleton />
  }

  return (<ShoppingCartV2 apiDetails={apiDetails} />)
}

export default ShoppingCart
